import { DndContext } from "@dnd-kit/core";
import { observer } from "mobx-react-lite";
import Parse from "parse";
import * as React from "react";
import { useState } from "react";
import {
  TicketSaveModal,
  TicketStateModal,
  useKanbanStates,
  useProject,
} from "../../..";
import {
  Kanban_State,
  Ticket_Kanban_State_Current,
} from "../../../../../js/parsegenerated";
import { KanbanContext } from "../../context/KanbanContext";
import { useDragHandler } from "../../hooks/useDragHandler";
import { DragHandlerData } from "../../types/Draggable";
import { KanbanColumn } from "../KanbanColumn";
import { KanbanLayout } from "../KanbanLayout";

type UpdateTicketStateData = {
  currentTicketKanbanStates: Ticket_Kanban_State_Current[];
  newState: Kanban_State;
};

type Props = {};

export const StateView = observer((props: Props) => {
  const { states } = useKanbanStates();
  const kanbanManager = React.useContext(KanbanContext);
  const [[saveModalOpen, saveModalState], setTicketSaveModal] = useState<
    [boolean, Kanban_State]
  >([false, undefined]);

  const { project } = useProject(
    kanbanManager.getDefaultTicketFilterConfig()?.filters?.project?.value ?? ""
  );

  const [dragResult, setDragResult] =
    useState<UpdateTicketStateData>(undefined);

  const dragHandler = useDragHandler(handleMoveState);

  async function handleMoveState(data: DragHandlerData) {
    const newState = await new Parse.Query(Kanban_State).get(data.destination);
    const currentTicketKanbanState = await new Parse.Query(
      Ticket_Kanban_State_Current
    )
      .equalTo("ticket", data.ticketData.ticket)
      .first();

    setDragResult({
      currentTicketKanbanStates: [currentTicketKanbanState],
      newState: newState,
    });
  }

  return (
    <div>
      <DndContext onDragEnd={dragHandler}>
        <KanbanLayout>
          {states.map((state) => {
            return (
              <KanbanColumn
                id={state.id}
                key={state.id}
                title={state.get("label")}
                openSaveModal={() => setTicketSaveModal([true, state])}
                ticketManagerConfig={{
                  filters: {
                    state: { attribute: "state", value: state.id },
                  },
                }}
              />
            );
          })}
        </KanbanLayout>
      </DndContext>

      <TicketStateModal
        ticketData={dragResult?.currentTicketKanbanStates}
        newState={dragResult?.newState}
        open={!!dragResult?.newState && !!dragResult?.currentTicketKanbanStates}
        onSaveSuccess={() => {
          try {
            kanbanManager.reload(
              dragResult.currentTicketKanbanStates[0].state.id
            );
            kanbanManager.reload(dragResult.newState.id);
          } catch (err) {
            console.log(err);
            kanbanManager.reload();
          }
          setDragResult(undefined);
        }}
        onSaveCancel={() => {
          setDragResult(undefined);
        }}
        onSaveError={() => {
          setDragResult(undefined);
        }}
      />

      <TicketSaveModal
        open={saveModalOpen}
        initialValues={{
          state: saveModalState?.id,
          project: project?.id,
        }}
        onSaveSuccess={() => {
          kanbanManager.reload(saveModalState?.id);
        }}
        onClose={() => setTicketSaveModal([false, undefined])}
      />
    </div>
  );
});
